// Components
import TableHeaders from "../../../components/table/TableHeaders";

//Page Constants
const tableHeaders = [
  {
    title: {
      displayName: "Day #",
      className: "font-weight-bold text-center col-3",
    },
  },

  {
    title: {
      displayName: "No. of Devices",
      className: "font-weight-bold text-center col-2",
    },
  },

  {
    title: {
      displayName: "New Devices",
      className: "font-weight-bold text-center col-2",
    },
  },

  {
    title: {
      displayName: "Frequency",
      className: "font-weight-bold text-center col-2",
    },
  },

  {
    title: {
      displayName: "Total Unique Devices",
      className: "font-weight-bold text-center col-3",
    },
  },
];

function ProgressTableRow({ eachDayInfo, dayIndex }) {
  const { deviceCount, uniqueDeviceCount, avgFrequency, totalUniqueDevices } =
    eachDayInfo;

  return (
    <tr>
      <td className="text-center">{dayIndex}</td>
      <td className="text-center">{deviceCount}</td>
      <td className="text-center">{uniqueDeviceCount}</td>
      <td className="text-center">
        {avgFrequency ? avgFrequency.toFixed(1) : "--"}
      </td>
      <td className="text-center">{totalUniqueDevices}</td>
    </tr>
  );
}

// Stretch Metrics Progress Table
export default function StretchMetricsProgressTable({ stretchMetrics }) {
  const { dailyData = [] } = stretchMetrics || {};

  // If No-Data
  if (dailyData.length < 1) {
    return null;
  }

  return (
    <>
      <h5 className="font-weight-bold">
        {"Stretch Metrics Progress (Day wise)"}
      </h5>
      <div className="table-responsive">
        <table className="table table-sm">
          <TableHeaders
            tableHeaders={tableHeaders}
            headerClass={"thead bg-alt"}
          />
          <tbody>
            {dailyData.map((eachDayInfo, i) => (
              <ProgressTableRow
                key={i}
                eachDayInfo={eachDayInfo}
                dayIndex={i + 1}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
